import React from "react";
import "./App.css";
import Main from "./pages/main";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AvaiableClasses from "./pages/avaiableClasses";
import JoinNow from "./pages/joinNow";
import Template from "./Component/template";
import Test from "./Component/test";
import PdfGenerator from "./pages/pdfGenrator";
function App() {
  return (
    <div className="w-full h-full bg-black ">
      <ToastContainer
        position="top-center" // Position of the toast
        autoClose={1500} // Duration of the toast (1.5 seconds)
        hideProgressBar={true} // Hide the progress bar
        closeButton={false} // Disable the close button (no cross)
        pauseOnHover={false} // Do not pause on hover
        draggable={false} // Disable dragging the toast
        newestOnTop={false} // Disable the bounce effect
        rtl={false}
      />
      <Router>
        <Switch>
          <Route exact path="/" component={Main} />
          <Route path="/classes/:id" component={AvaiableClasses} />
          <Route path="/joinNow" component={JoinNow} />
          <Route path="/template" component={Template} />
          <Route path="/test" component={Test} />
          <Route path="/receipt/:id" component={PdfGenerator} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
